export default __webpack_public_path__ + "static/2013-ultrafest-at-c737934b6eee2c80039ea15e91b87d99.pdf";